import React, { Component } from "react";
import { observer } from "mobx-react";
import { DIMENSIONS } from "utils/Dimensions";
//todo:  check this file :)
class Pages extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: props.gridApi.paginationGetCurrentPage(),
      rowsPerPage: 20,
      pageSizesAvailable: [20, 50, 100, 500, 1000, 2000],
      propsData: props,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({ propsData: nextProps });
  }

  render() {
    const isFilterActive =
      this.state.propsData.gridApi.getFilterModel() &&
      Object.keys(this.state.propsData.gridApi.getFilterModel()).length !== 0
        ? true
        : false;
    const { currentRowsCount, isLoading, shouldLoadAllRows } = this.props.store;

    return (
      <div
        className="d-flex pageRowContainer"
        style={{
          height: DIMENSIONS.status_bar,
        }}
      >
        <div
          className="d-flex"
          style={{
            flex: 1,
            visibility:
              this.state.propsData.rangeSelectionCalculations
                .selectedCellsCount > 1
                ? "visible"
                : "hidden",
            justifyContent: "flex-end",
          }}
        >
          <div className="pageRowContents">
            {this.state.propsData.rangeSelectionCalculations.sum ||
            this.state.propsData.rangeSelectionCalculations.sum === 0
              ? "Sum: " + this.state.propsData.rangeSelectionCalculations.sum
              : ""}
          </div>
          <div className="pageRowContents">
            {this.state.propsData.rangeSelectionCalculations.average ||
            this.state.propsData.rangeSelectionCalculations.average === 0
              ? "Average: " +
                this.state.propsData.rangeSelectionCalculations.average
              : ""}
          </div>
          <div className="pageRowContents">
            {this.state.propsData.rangeSelectionCalculations.minimum ||
            this.state.propsData.rangeSelectionCalculations.minimum === 0
              ? "Minimum: " +
                this.state.propsData.rangeSelectionCalculations.minimum
              : ""}
          </div>
          <div className="pageRowContents">
            {this.state.propsData.rangeSelectionCalculations.maximum ||
            this.state.propsData.rangeSelectionCalculations.maximum === 0
              ? "Maximum: " +
                this.state.propsData.rangeSelectionCalculations.maximum
              : ""}
          </div>
          <div className="pageRowContents">
            {this.state.propsData.rangeSelectionCalculations
              .selectedCellsCount ||
            this.state.propsData.rangeSelectionCalculations
              .selectedCellsCount === 0
              ? "Count: " +
                this.state.propsData.rangeSelectionCalculations
                  .selectedCellsCount
              : ""}
          </div>
        </div>
        {shouldLoadAllRows && isLoading ? (
          "Loading.."
        ) : (
          <div className="pageRowContents">
            {!isNaN(parseInt(currentRowsCount))
              ? currentRowsCount + " records"
              : ""}
          </div>
        )}
      </div>
    );
  }
}

export default observer(Pages);
